import React, { Component } from 'react'
import timezones_list from './timezones'
import moment from 'moment-timezone'
import './calendar.css'
import averageRatingImg from  '../img/average-rating.png'

class Now {
	constructor(){
		this.update();
		// setInterval( this.update.bind(this), 15000 );
	}
	update(){
		this.moment = moment();
		this.min = this.moment.format('mm');
	}
}

let now = new Now();



let timezones = timezones_list.map( z => {
	let zone_object = moment.tz( now.moment, z.title );
	z.title_formatted = `${zone_object.format("Z")} - ${z.title} - ${zone_object.format("z")}`;
	return z;
});
// console.log(timezones);


let skills = [`HTML`, `CSS`,`Javascript`, `ES6`,`⚛ React`,`JSX`, `React-Router`, `Redux`, `Material-UI`,`Firebase for Web: Database, Auth, Storage, Hosting, Functions`,`jQuery`, `Backbone`, `Marionette`,`AJAX`, `Axios`, `fetch`,`async`,`Git`, `Github`,`npm`, `yarn`,`Chrome DevTools`,`CSS Frameworks`, `Bootstrap`, `Bulma`, `Foundation`, `Semantic-UI`, `SASS`,`Handlebars`,`NodeJS`, `ExpressJS`, `MongoDB`,`Webpack`, `Browserify`, `Gulp`, `Bower`, `Require.js`,`Jekyll`];



class App extends Component {
	constructor(props) {
		super(props);
		this.state = { ctz: moment.tz.guess() }
		this.updateTimezone = this.updateTimezone.bind(this);
	}

	updateTimezone(z){
		// console.log('[updateTimezone]', z);
		this.setState({ ctz: z })
	}

	iframeSrc(){
		let params = [`showTitle=0`,
				`showPrint=0`,
				`mode=WEEK`,
				`height=600`,
				`wkst=2`,
				`bgcolor=%23FFFFFF`,
				`src=0ak2e8mmi70s1aqrbqspnu1vjc%40group.calendar.google.com`,
				`color=%23333333`];
		this.state.ctz && params.push(`ctz=${this.state.ctz}`);
		return `https://calendar.google.com/calendar/embed?${params.join('&')}`;
	}

	render() {
		return (
			<div>

				<div className="columns">
					<div className="column">
						<div className="tags">
							<span className="tag is-white">Ask me about: </span>
							{skills.map( (skill,i) => {
								return (
									<div key={i} className="tag skill">{skill}</div>
									
								)
							})}
						</div>
					</div>
					<div className="column" style={{flexGrow:0, minWidth: 140}}>
						<a href="https://www.codementor.io/yurio/reviews"><img src={averageRatingImg} alt=""/></a>
					</div>
				</div>




				<div className="columns" style={{alignItems:'flex-end'}}>
					<div className="column timezone-selector-container">

						<div className="field">
							<label className="label is-medium">Your timezone:</label>
							<div className="control has-icons-left">
								<span className="select" style={{maxWidth:300}}>
									<TimezoneSelector ctz={this.state.ctz} handleChange={this.updateTimezone} />
								</span>
								<span className="icon is-small is-left">
									<i className="fal fa-watch"></i>
								</span>
							</div>
						</div>


					</div>
					<div className="column">
						<article className="message is-warning">
							<div className="message-body">
								This calendar only tells when I am definitely busy. I may not be available immediately, especially on weekends ;)
								<br/>
								Please <a href="https://www.codementor.io/yurio">message me</a> for any information.
							</div>
						</article>

					</div>
				</div>

				<iframe id="iframe_cal" src={this.iframeSrc()} title="Calendar" style={{borderWidth:0}} width="800" height="600" frameBorder="0" scrolling="no"></iframe>
			</div>
		);
	}
}

class TimezoneSelector extends React.Component {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
	}
	handleChange(e) {
		this.props.handleChange(e.target.value);
	}
	render(){
		return <select className="timezoneSelector" value={this.props.ctz} onChange={this.handleChange}>{
			timezones.map( z => {
				return <option value={z.title} key={z.title}>{z.title_formatted}</option>
			})
		}</select>
	}
}


export default App;


// WEBPACK FOOTER //
// ./src/Calendar/Calendar.js